import React from 'react';
import { Camera, ImageIcon } from 'lucide-react';

const Photos = () => {
  // Placeholder: à remplir après la soirée avec vos vraies photos
  const photos = [];

  return (
    <div className="min-h-screen bg-gradient-to-b from-black via-neutral-900 to-black py-20 px-4">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <Camera className="w-16 h-16 text-orange-500 mx-auto mb-4" />
          <h1 className="text-6xl md:text-7xl font-black mb-6 text-transparent bg-clip-text bg-gradient-to-r from-orange-400 via-amber-500 to-orange-600">
            Photos de la soirée
          </h1>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto">
            Revivez les meilleurs moments de notre aventure post-apocalyptique
          </p>
        </div>

        {photos.length === 0 ?
        <div className="bg-neutral-800/50 backdrop-blur-sm p-12 rounded-xl border-2 border-orange-600/30 text-center">
            <ImageIcon className="w-20 h-20 text-orange-500/50 mx-auto mb-6" />
            <h2 className="text-3xl font-bold text-orange-400 mb-4">
              Les photos arrivent bientôt !
            </h2>
            <p className="text-lg text-gray-300 max-w-xl mx-auto">


          </p>
          </div> :

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {photos.map((photo, index) =>
          <div
            key={index}
            data-testid={`event-photo-${index}`}
            className="group relative overflow-hidden rounded-xl border-2 border-orange-600/30 hover:border-orange-500 transition-all duration-500 hover:scale-105">

                <div className="aspect-square overflow-hidden">
                  <img
                src={photo.url}
                alt={photo.caption || `Photo ${index + 1}`}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />

                </div>
              </div>
          )}
          </div>
        }
      </div>
    </div>);

};

export default Photos;